module.exports = __webpack_public_path__ + "img/hollywood-icon.81d1dd28.svg";